export const AssignmentActionTypes = {
  SET_QUESTION_LIST: "SET_ASSIGNMENT_QUESTION_LIST",
  ADD_QUESTION: "ADD_ASSIGNMENT_QUESTION",
  EDIT_QUESTION: "EDIT_ASSIGNMENT_QUESTION",
  DELETE_QUESTION: "DELETE_ASSIGNMENT_QUESTION",
};
